import * as serviceContext from "./serviceContext";
import { OPERATOR_ID } from "../configs/const";
import { XOROPE_ROOT } from "../configs/api";

var options = {};
var headers = new Headers();

headers.append("Content-Type", "application/json");
options.headers = headers;

export async function getXoroData(data) {
  try {
    // XOROPE_ROOT + "PaymentGateway/GetActivePG/" + OPERATOR_ID,
    const response = await serviceContext.post(
      "pgi/Orders/xoropeoptions",// + OPERATOR_ID,
      JSON.stringify(data),
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function postManualPayment(data) {
  try {
    // XORO_API + "ManualPayment",
    const response = await serviceContext.post(
      "pgi/Orders/manualpayment",
      data,
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function postManualPaymentJson(data) {
  try {
    // XORO_API + "ManualPayment",
    const response = await serviceContext.post(
      "pgi/Orders/newmanualpayment",
      JSON.stringify(data),
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}



export async function getManualWithdrawal(dt) {
  try {
    // XORO_API + "ManualPayment",
    // "pgi/withdrawals/options/"+ OPERATOR_ID,
    const response = await serviceContext.get(
      'pgi/withdrawals/options',
      null,
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function getXoroActiveProviderData() {
  try {
    // XOROPE_ROOT + "PaymentGateway/GetActivePG/" + OPERATOR_ID,https://api-dev.1xbook.com/pgi/Orders/activeprovider/RDR - GET
    const response = await serviceContext.get(
      "pgi/Orders/activeprovider/" + OPERATOR_ID,
      null,
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}


export async function postMQRManualPayment(data) {
  try {
    // XORO_API + "ManualPayment",
    const response = await serviceContext.post(
      "pgi/Orders/mqrpayment",
      JSON.stringify(data),
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}




export async function getMyPreviousBank(data) {
  try {
    // XORO_API + "ManualPayment",
    const response = await serviceContext.get(
      `pgi/withdrawals/getmybank/${data.oid}/${data.user}`,
      null,
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function deleteMyPreviousBank(data) {
  try {
    // XORO_API + "ManualPayment",
    const response = await serviceContext.post(
      `pgi/withdrawals/deletemybank`,
      JSON.stringify(data),
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}


export async function getDepositBonusOffers(oid) {
  try {
    // XORO_API + "ManualPayment",
    const response = await serviceContext.get(
      `pgi/orders/getbonuspercentage/${oid}`,
      null,
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function getIFSCCodeDetails(ifsccode) {
  return new Promise((resolve, reject) => {
      fetch(`https://ifsc.razorpay.com/${ifsccode.toUpperCase()}`)
          .then((response) => response.json())
          .then((res) => {
              resolve(res)
          })
  })

  // return res;

}


export async function getXoroDataNew(data) {
  try {
    // XOROPE_ROOT + "PaymentGateway/GetActivePG/" + OPERATOR_ID, https://api-dev.1xbook.com/pgi/orders/depositoptions
    const response = await serviceContext.get(
      "pgi/orders/depositoptions",// + OPERATOR_ID,
      null,
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function submitWithUtr(data) {
  try {
    const response = await serviceContext.post(`pgi/orders/updatemqrutr`, JSON.stringify(data), options);
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}


export async function getBonusOffersDetails(type) {
  try {
    // XORO_API + "ManualPayment",
    const response = await serviceContext.get(
      `pgi/clientbonus/details/${type}`,
      null,
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}


export async function getApniIFSCCodeDetails(ifsc) {
  try {
    // XORO_API + "ManualPayment",
    const response = await serviceContext.get(
      `pgi/Ifscdetails/${ifsc}`,
      null,
      options
    );
    if (response.hasError === true) {
      return false;
    } else {
      const res = response.json();
      return res;
    }
  } catch (error) {
    return error;
  }
}